export const navItems = [
  { id: 'home', label: '首页' },
  { id: 'today', label: '今日速览' },
  { id: 'categories', label: '分类目录' },
  { id: 'ranking', label: '热度排行' },
  { id: 'dossier', label: '深度档案' },
  { id: 'topics', label: '标签导航' },
  { id: 'faq', label: '常见问答' },
  { id: 'about', label: '关于我们' },
];

export const tickerItems = [
  '某档综艺路透流出，节目组回应"剪辑并非全貌"',
  '人气主播 K 直播首次回应合约风波，观看人数破三百万',
  '行业观察：热播剧宣发节奏为何越来越依赖话题词条',
  '多位博主晒出同一品牌合作画面，网友整理时间线',
  '社会话题：外卖骑手夜间保障新规引发集中讨论',
  '老牌乐队巡演加场，票务平台整理防骗提醒',
  '财经观察：MCN 机构与内容创作者的合约结构再受关注',
  '影视榜单更新，三部悬疑剧同时进入讨论量前五',
];

export const categories = [
  {
    id: 'star',
    name: '明星话题',
    desc: '关注荧幕内外的公开动态、行程路透与作品相关讨论。',
    count: 1284,
    icon: 'ri-star-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20stage%20spotlight%20scene%20with%20crimson%20and%20gold%20tones%2C%20dark%20editorial%20magazine%20aesthetic%2C%20soft%20glow%20and%20smoke%2C%20minimal%20composition%2C%20warm%20shadow&width=800&height=600&seq=heiliao-cat-star-01&orientation=landscape',
  },
  {
    id: 'influencer',
    name: '网红圈',
    desc: '短视频与直播间里的热门账号动态、合作与口碑记录。',
    count: 967,
    icon: 'ri-live-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20ring%20light%20and%20camera%20silhouette%2C%20deep%20maroon%20background%20with%20amber%20glow%2C%20dark%20editorial%20magazine%20aesthetic%2C%20minimal%20geometric%20composition&width=800&height=600&seq=heiliao-cat-influencer-01&orientation=landscape',
  },
  {
    id: 'business',
    name: '政商观察',
    desc: '公开信息范围内的行业动向、企业事件与政策相关解读。',
    count: 543,
    icon: 'ri-building-2-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20city%20skyline%20in%20dusk%20with%20warm%20gold%20windows%20and%20deep%20red%20tones%2C%20dark%20editorial%20aesthetic%2C%20minimal%20geometric%20shapes&width=800&height=600&seq=heiliao-cat-business-01&orientation=landscape',
  },
  {
    id: 'society',
    name: '社会热点',
    desc: '与日常生活相关、引发广泛讨论的公开社会话题整理。',
    count: 812,
    icon: 'ri-earth-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20night%20street%20with%20warm%20lanterns%20and%20crimson%20accents%2C%20dark%20editorial%20documentary%20aesthetic%2C%20soft%20rain%20reflection%2C%20minimal%20composition&width=800&height=600&seq=heiliao-cat-society-01&orientation=landscape',
  },
  {
    id: 'screen',
    name: '影视风云',
    desc: '剧集与电影的选角、宣发、口碑与幕后公开信息聚合。',
    count: 726,
    icon: 'ri-film-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20cinema%20hall%20with%20deep%20red%20curtain%20and%20golden%20projector%20beam%2C%20dark%20editorial%20aesthetic%2C%20minimal%20geometric%20composition&width=800&height=600&seq=heiliao-cat-screen-01&orientation=landscape',
  },
  {
    id: 'variety',
    name: '综艺现场',
    desc: '综艺节目的嘉宾阵容、环节设置与录制花絮话题索引。',
    count: 634,
    icon: 'ri-mic-line',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20variety%20show%20stage%20with%20warm%20amber%20beams%20and%20crimson%20backdrop%2C%20dark%20editorial%20aesthetic%2C%20minimal%20composition&width=800&height=600&seq=heiliao-cat-variety-01&orientation=landscape',
  },
];

export const hotTopics = [
  {
    id: 'ht-1',
    title: '一部热播悬疑剧的"开放式结局"为何掀起两派争论',
    summary:
      '剧集收官后，观众围绕结局是否留下第二季线索展开长线讨论。我们整理了公开的采访片段与主创回应，按时间顺序还原话题走向。',
    category: '影视风云',
    heat: 9860,
    tag: '热播剧',
    time: '2小时前',
  },
  {
    id: 'ht-2',
    title: '人气主播 K 停播两周后的首次直播，都说了些什么',
    summary:
      '这场直播没有预告却涌入大量观众。围绕合约细节的传闻很多，本文只呈现主播本人在直播中公开表述的内容与上下文。',
    category: '网红圈',
    heat: 8720,
    tag: '直播间',
    time: '5小时前',
  },
  {
    id: 'ht-3',
    title: '同一组品牌合作画面被多位博主发出，时间线梳理',
    summary:
      '网友发现几位博主的合作内容画面高度相似。我们按发布时间整理了公开可见的动态，帮助读者理解事情的先后顺序。',
    category: '网红圈',
    heat: 7310,
    tag: '品牌合作',
    time: '8小时前',
  },
  {
    id: 'ht-4',
    title: '音乐节退票风波：主办方公告与观众诉求的差异点在哪',
    summary:
      '针对天气原因导致的临时调整，主办方发布公告，观众则提出补偿诉求。本文对比双方公开说明，标注关键分歧。',
    category: '社会热点',
    heat: 6540,
    tag: '演出',
    time: '11小时前',
  },
  {
    id: 'ht-5',
    title: '当"数据好等于作品好"被反复质疑，行业在讨论什么',
    summary:
      '从榜单到热搜，围绕数据表现的讨论持续升温。我们汇总了几位从业者的公开观点，梳理争议背后的行业语境。',
    category: '明星话题',
    heat: 5890,
    tag: '行业观察',
    time: '14小时前',
  },
  {
    id: 'ht-6',
    title: '某老牌乐队巡演加场，票务平台的防骗提醒值得一看',
    summary:
      '加场消息发布后，二级市场出现大量转让信息。本文整理官方票务渠道的公开提示，帮助观众避开常见陷阱。',
    category: '社会热点',
    heat: 4760,
    tag: '演出安全',
    time: '1天前',
  },
];

export const ranking = [
  { rank: 1, title: '悬疑剧开放式结局争论持续，主创采访片段被反复引用', category: '影视风云', heat: '9860', trend: 'up' },
  { rank: 2, title: '人气主播 K 停播两周后首次直播回应引发关注', category: '网红圈', heat: '8720', trend: 'up' },
  { rank: 3, title: '同一组品牌合作画面被多位博主发出，时间线被整理', category: '网红圈', heat: '7310', trend: 'flat' },
  { rank: 4, title: '音乐节退票风波：主办方公告与观众诉求对比', category: '社会热点', heat: '6540', trend: 'up' },
  { rank: 5, title: '数据表现与作品质量的关系被反复讨论，从业者发声', category: '明星话题', heat: '5890', trend: 'down' },
  { rank: 6, title: '老牌乐队巡演加场，票务平台发布防骗提醒', category: '社会热点', heat: '4760', trend: 'up' },
  { rank: 7, title: '综艺路透流出后节目组回应"剪辑并非全貌"', category: '综艺现场', heat: '4430', trend: 'flat' },
  { rank: 8, title: '热播剧宣发节奏被拆解，话题词条投放方式受关注', category: '影视风云', heat: '4120', trend: 'down' },
  { rank: 9, title: 'MCN 机构与内容创作者合约结构再成讨论焦点', category: '政商观察', heat: '3760', trend: 'up' },
  { rank: 10, title: '社交媒体话题词条如何生成，行业流程被公开讲述', category: '网红圈', heat: '3450', trend: 'flat' },
];

export const tags = [
  '热播剧',
  '直播间',
  '品牌合作',
  '行业观察',
  '演出安全',
  '行程路透',
  '合约风波',
  '数据争议',
  '综艺花絮',
  '选角传闻',
  '票务提醒',
  '新人出道',
  '榜单变化',
  '宣发节奏',
  '粉丝应援',
  '公开声明',
  '媒体采访',
  '话题词条',
  '跨界合作',
  '账号停更',
];

export const dossier = {
  kicker: '深度档案 · 第 044 期',
  title: '"黑料"是怎么被整理成目录的：一次话题生命周期复盘',
  meta: '44黑料区 编辑部 · 更新于 2026年9月12日 · 阅读约 8 分钟',
  cover:
    'https://readdy.ai/api/search-image?query=stylized%20abstract%20stack%20of%20newspapers%20and%20dossier%20folders%20with%20crimson%20and%20gold%20accents%2C%20dark%20editorial%20still%20life%2C%20soft%20directional%20light%2C%20minimal%20composition%2C%20warm%20shadow&width=1200&height=800&seq=heiliao-dossier-01&orientation=landscape',
  blocks: [
    {
      heading: '一、话题从哪来：先分源头',
      body: '一条娱乐话题通常有多个起点：节目路透、平台榜单变化、从业者采访、品牌合作动态。把它们混在一起看，很容易得出片面结论。我们会先标注每条信息的来源类型，再决定它进入哪个分区目录。',
    },
    {
      heading: '二、如何归档：标签先于排序',
      body: '在"44黑料区"，标签不是装饰，而是检索入口。一个话题往往同时属于"热播剧"和"宣发节奏"两个标签。我们按主话题划分主目录，再补充交叉标签，让同一件事可以从不同路径被找到。',
    },
    {
      heading: '三、热度的口径：把数字放回语境',
      body: '热度值只是排序参考，不代表事件的性质或真伪。我们会在话题页标注热度采集的时间点，并提醒读者：数值变化快，请以最新公开信息为准。数字越高，不等于越可信。',
    },
    {
      heading: '四、边界在哪里：只整理公开信息',
      body: '本目录只收录公开可见、可回溯的内容，不发布未经证实的指控，也不针对真实个人做出评价性结论。若信息涉及隐私或存在明显错误，欢迎通过订阅页下方的联系方式提醒我们更正。',
    },
  ],
};

export const faqs = [
  {
    q: '44黑料区的"分类目录"具体怎么划分？',
    a: '目录按明星话题、网红圈、政商观察、社会热点、影视风云、综艺现场六个主分区组织。每个分区内部再以标签做交叉索引，你可以从分区进入，也可以用标签导航横向定位相关内容。',
  },
  {
    q: '标签导航和普通搜索有什么区别？',
    a: '搜索需要你先想好关键词，而标签导航是"先浏览、再聚焦"。每个标签都对应一批已归档的话题，点击标签即可看到相关条目，适合还没明确目标时快速了解某个领域的讨论范围。',
  },
  {
    q: '热度排行是怎么计算的？',
    a: '热度值综合了公开讨论量、内容更新频率与互动规模的相对变化，用于排序参考。它只反映关注度，不代表事件性质或信息真实性，具体数值请结合话题页标注的采集时间来判断。',
  },
  {
    q: '目录里的内容会持续更新吗？',
    a: '会。编辑团队按栏目定期复核，过时或已被公开更正的信息会归档或标注更新说明。订阅"黑料速递"后，你能在每周简报里看到新增与修订的条目摘要。',
  },
  {
    q: '如果发现目录里的信息有误怎么办？',
    a: '请通过订阅页的联系邮箱反馈，并附上可核实的公开来源。我们核实后会尽快更正或下架相关条目，并在对应话题页留下修订记录。',
  },
  {
    q: '浏览目录需要注册账号吗？',
    a: '不需要。目录浏览与标签导航完全开放，也不要求登录。只有订阅速递简报时才需要留下邮箱，且可随时取消。',
  },
];

export const testimonials = [
  {
    name: '林小姐',
    role: '内容运营',
    text: '以前追娱乐话题全靠刷信息流，越刷越乱。这里的分类目录把"哪些是同一个话题"理清楚了，做选题参考特别省时间。',
  },
  {
    name: '周先生',
    role: '影视爱好者',
    text: '标签导航是我用得最多的功能。想看某部剧的宣发讨论，点一下标签就全出来了，不用在搜索框里反复换词。',
  },
  {
    name: '阿珂',
    role: '社媒观察者',
    text: '热度排行会标注采集时间这点很加分，至少让人知道数字是"什么时候的"，不会被过期的榜单误导。',
  },
  {
    name: '陈同学',
    role: '在校学生',
    text: '页面干净、分区清楚，逛起来不像很多话题站那样满屏弹窗。常见问答也把规则讲明白了，知道内容边界在哪。',
  },
];

export const metrics = [
  { value: '4,966+', label: '已归档话题条目' },
  { value: '6', label: '主分区目录' },
  { value: '20', label: '常用检索标签' },
  { value: '每日', label: '目录复核更新' },
];